export default {
    install(Vue) {
        const requireComponent = require.context('../components/ui', false, /\.(js|vue)$/i);

        requireComponent.keys().forEach(fileName => {
            const componentConfig = requireComponent(fileName);
            const componentName = fileName
                .replace(/^\.\//, '')
                .replace(/\.\w+$/, '')
                .split('-')
                .map((kebab) => kebab.charAt(0).toUpperCase() + kebab.slice(1))
                .join('');

            Vue.component(componentName, componentConfig.default || componentConfig);
        });
    },
};
